import PropTypes from "prop-types";

export const formatCount = (count, noun) =>
  `${count} ${noun}${count === 1 ? "" : "s"}`;

export const getRegistrantLabel = registrant =>
  registrant.name || registrant.email;

/** Maps each session of the registrants, by id, to its name. */
export const getSessionNames = registrants =>
  new Map(
    registrants.flatMap(registrant =>
      (registrant.sessions ?? []).map(session => [session.id, session.name])
    )
  );

export const registrantShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string,
  email: PropTypes.string,
  sessions: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.number, name: PropTypes.string })
  ),
});
